import React from "react";
import MenuButton from "./MenuButton";

const GeneralQueriesWidget = ({ actions }) => {
  const questions = [
    "Why do I need insurance?",
    "How do I choose the right insurance policy?",
    "How does a claim process work?",
    "Which is better: Life Insurance or Term Insurance?",
  ];

  return (
    <div>
      {questions.map((question, index) => (
        <button
          key={index}
          onClick={() => {
            actions.handleSuggestedQuestionClick(question);
          }}
          className="text-sm text-start font-medium border border-customBlue hover:bg-gray-100 py-0.5 px-3 m-1 rounded-full"
        >
          {question}
        </button>
      ))}
      <MenuButton actions={actions} />
    </div>
  );
};

export default GeneralQueriesWidget;
